import { Component, OnInit, Pipe, ViewChild, ElementRef, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { DashBoardService } from 'app/main/pages/dashboard/dashboard.services';
import { ChartOptions, ChartType, ChartDataset, ChartConfiguration } from 'chart.js';

import { makeDrawValuePlugin } from '../chartjs.plugins';
import { takeUntil } from 'rxjs/operators';
import { DestroyableComponent } from 'app/main/destroyable.component';
import chartColors from './../chart-colors';

@Component({
    selector: 'traveldate',
    templateUrl: './traveldate.component.html',
    styleUrls: ['../dashboard.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TravelDateComponent extends DestroyableComponent implements OnInit{

	public travels: ChartDataset[];
	public chartData: ChartConfiguration['data'];
	public chartPlugins = [makeDrawValuePlugin()];
	public showLoader: boolean;

	/**
	 * Chart Travel Date
	*/
	public barChartOptions: ChartOptions<'line'> = {
		responsive: true,
		maintainAspectRatio: false,
		scales: {
			x: {},
			y: {
				ticks: {
					callback: function (value): string{
						return Number(value).toLocaleString('US');
					}
				}
			}
		},
		plugins: {
			legend: {
				position: 'bottom',
				fullSize: true,
				labels: {
					usePointStyle: true,
					padding: 10,
				}
			},
			tooltip: {
				cornerRadius: 8,
				padding: { top: 6, bottom: 6, left: 8, right: 8 },
				caretSize: 0,
				caretPadding: 10,
				backgroundColor: '#b5b5b5',
				displayColors: false,
				callbacks: {
					label: function(tooltipItem): string {
						const n = Number(tooltipItem.parsed.y);
						if(!n || isNaN(n)) return '';
						return n.toLocaleString('US');
					},
					title: function(items): string{
						return;
					},
				},
			},
		},
	};
	public barChartLabels: string[] = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'];
	public barChartType: ChartType = 'line';
	public barChartLegend = true;
	constructor(
		public dashboardService: DashBoardService
	){
		super();
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void{
		this.dashboardService.travelDateResponse
		.pipe(takeUntil(this._unsubscribeAll))
		.subscribe({
			next: (response: any) => {
				this.onData(response);
			}
		});
	}

	public onData(response: any): void{
		if(!response){
			this.showLoader = true;
			return;
		}
		const r = [];
		for(let i = 0; i < response.length; i++){
			const year = response[i].year;
			const month = response[i].month - 1;
			if (!r[year]) r[year] = [];
			if (!r[year][month]) r[year][month] = 0;
			r[year][month] += response[i].total_amount;
		}
			
		for (let y = 0; y < Object.keys(r).length; y++){
			const year = Object.keys(r)[y];
			for (let m = 0; m < 12; m++){
				if (!r[year][m]) r[year][m] = 0;
			}
		}
			
		const data: ChartDataset[] = [];
		const years = Object.keys(r);
		for (let y = 0; y < years.length; y++){
			const year = years[y];
			if(!r[year]) continue;
			const colorIndex = years.length - y - 1;
			data.push({
				data: r[year],
				label: year.toString(),
				tension: 0,
				fill: false,
				backgroundColor: chartColors[colorIndex],
				borderColor: chartColors[colorIndex],
				hoverBackgroundColor: chartColors[colorIndex],
				pointBackgroundColor: chartColors[colorIndex],
				pointHoverBackgroundColor: chartColors[colorIndex],
				pointHoverBorderColor: chartColors[colorIndex],
				pointRadius: 5,
			});
		}
		if(!data || data.length === 0){
			this.showLoader = true;
			this.travels = null;
			this.chartData = null;
		} else {
			this.showLoader = false;
			this.travels = data;
			this.chartData = { labels: this.barChartLabels, datasets: data };
		}
	}
	// -----------------------------------------------------------------------------------------------------
	
}
